var FaqDataTestId = /* @__PURE__ */ ((FaqDataTestId2) => {
  FaqDataTestId2["FAQ_PROFESSIONAL_TAB_TRIGGER"] = "faq--professional-tab-trigger";
  FaqDataTestId2["FAQ_PATIENT_TAB_TRIGGER"] = "faq--patient-tab-trigger";
  FaqDataTestId2["FAQ_FIND_BRANCH_BUTTON"] = "faq--find-branch-button";
  FaqDataTestId2["FAQ_EMAIL_SAC_BUTTON"] = "faq--email-sac-button";
  FaqDataTestId2["FAQ_ASSISTED_SHOPPING_BUTTON"] = "faq--assisted-shopping-button";
  FaqDataTestId2["FAQ_PROFESSIONAL_BE_OUR_PARTNER_BUTTON"] = "faq--professional-be-our-partner-button";
  FaqDataTestId2["FAQ_PROFESSIONAL_ENTER_SYSTEM_BUTTON"] = "faq--professional-enter-system-button";
  FaqDataTestId2["FAQ_SUPPORT_PROFESSIONALS_WHATSAPP_SAC"] = "faq--support-professionals-whatsapp-sac";
  FaqDataTestId2["FAQ_HELP_SEARCH_HERO"] = "faq--help-search-hero";
  FaqDataTestId2["FAQ_HELP_SEARCH_INPUT"] = "faq--help-search-input";
  FaqDataTestId2["FAQ_MOST_ACCESSED_SECTION"] = "faq--most-accessed-section";
  FaqDataTestId2["FAQ_HELP_POST_CARD"] = "faq--help-post-card";
  FaqDataTestId2["FAQ_HELP_POST_LINK"] = "faq--help-post-link";
  FaqDataTestId2["FAQ_HELP_POST_TITLE"] = "faq--help-post-title";
  FaqDataTestId2["FAQ_HELP_POST_DETAIL"] = "faq--help-post-detail";
  FaqDataTestId2["FAQ_HELP_RELATED_QUESTIONS"] = "faq--help-related-questions";
  FaqDataTestId2["FAQ_RESCHEDULE_BRANCH_CARD"] = "faq--reschedule-branch-card";
  FaqDataTestId2["FAQ_RESCHEDULE_ONLINE_CARD"] = "faq--reschedule-online-card";
  FaqDataTestId2["FAQ_BECOME_PARTNER_CARD"] = "faq--become-partner-card";
  FaqDataTestId2["FAQ_PROFESSIONAL_CONTACT_CARD"] = "faq--professional-contact-card";
  FaqDataTestId2["FAQ_PATIENT_CONTACT_CARD"] = "faq--patient-contact-card";
  FaqDataTestId2["FAQ_PATIENT_WHATSAPP_SAC_BUTTON"] = "faq--patient-whatsapp-sac-button";
  FaqDataTestId2["FAQ_PARTNER_SIMPLIFY_SCHEDULE"] = "faq--partner-simplify-schedule";
  return FaqDataTestId2;
})(FaqDataTestId || {});
export {
  FaqDataTestId
};
